import {
  action,
  observable,
  makeObservable,
} from "mobx";

class LimitsAndPayoutsStore {
  limitsPayouts = [];

  constructor() {
    makeObservable(this, {
      limitsPayouts: observable.deep,
        setLimitsAndPayouts: action.bound,
    });
  };

  setLimitsAndPayouts(limitsPayouts) {
    this.limitsPayouts = limitsPayouts;
  };

};

export const limitsAndPayoutsStore = new LimitsAndPayoutsStore();
